module.exports = __webpack_public_path__ + "img/yangImg4.c9c0acbe.jpg";